import { translateObject } from '@huggg/bar-staff';
import { prop } from 'ramda';
import { urls } from '../config';
import withAxios from '../utils/with-axios';
import { auditLogMap } from '../translationMaps';
function formatAuditLog(data) {
  return translateObject(auditLogMap, data);
}
function formatAllResponse(data) {
  return data.map(formatAuditLog);
}

/**
 * Fetch all audit logs for a given transaction ID
 *
 * @param {Object} $axios [$axios=axios] Axios instance.
 * @param {String} transactionId
 * @returns {Promise} Unresolved Promise from the API.
 */
function allByTransactionId($axios, transactionId) {
  if (!transactionId) {
    throw new Error('Prop `transactionId` is required in `auditLogs.allByTransactionId`');
  }
  return $axios.get(urls.apiV2("/transactions/".concat(transactionId, "/audit-logs"))).then(prop('data')).then(formatAllResponse);
}
export default {
  allByTransactionId: withAxios(allByTransactionId)
};